import { adminHttpClient } from '../../commons/adminHttpClient'
import ClassTypeIds from '../../../domain/benefit/classTypeIds'
import ReimbursementProduct from '../../../domain/benefit/reimbursementProduct'

export type BenefitProductClassResponse = {
  id: string
  name: string
  classTypeId: number
  designCompleted: boolean
  totalEmployees: number
  offerSameAllowance: boolean
  classTypeIds: number[]
  stateId?: string
  reimbursementProduct: {
    id: ReimbursementProduct
    name: string
  }
}

const getBenefitProductClasses = (planPeriodId: string): Promise<BenefitProductClassResponse[]> => {
  return adminHttpClient.get(`/AdminDashboard/Benefit/BenefitProductClasses/${planPeriodId}`)
}

export default getBenefitProductClasses

export const mockGetBenefitProductClasses = (planPeriodId: string) =>
  Promise.resolve([
    {
      id: '1',
      name: 'Full Time',
      classTypeId: ClassTypeIds.FullTimeId,
      designCompleted: true,
      totalEmployees: 0,
      offerSameAllowance: true,
      classTypeIds: [ClassTypeIds.FullTimeId],
    },
    {
      id: '2',
      name: 'Seasonal',
      classTypeId: ClassTypeIds.Seasonal,
      designCompleted: true,
      totalEmployees: 100,
      offerSameAllowance: true,
      classTypeIds: [ClassTypeIds.Seasonal],
    },
  ])
